// extracted by mini-css-extract-plugin
export default {"main":"style_main__cwqGG","catalogContainer":"style_catalogContainer__hcHl9"};